import { gql, useMutation } from '@apollo/client';

/* ============================================
   GRAPHQL MUTATION DEFINITIONS
   ============================================ */

// Create ride.
const CREATE_RIDE = gql`
  mutation CreateRide(
    $riderId: ID
    $riderName: String!
    $phoneNumber: String!
    $passengers: Int!
    $pickUp: String!
    $pickUpLat: Float
    $pickUpLng: Float
    $dropOff: String!
    $dropOffLat: Float
    $dropOffLng: Float
    $pickUpTime: String!
    $bidAmount: Int
    $requestedDriverIds: [ID]
  ) {
    createRide(
      riderId: $riderId
      riderName: $riderName
      phoneNumber: $phoneNumber
      passengers: $passengers
      pickUp: $pickUp
      pickUpLat: $pickUpLat
      pickUpLng: $pickUpLng
      dropOff: $dropOff
      dropOffLat: $dropOffLat
      dropOffLng: $dropOffLng
      pickUpTime: $pickUpTime
      bidAmount: $bidAmount
      requestedDriverIds: $requestedDriverIds
    ) {
      id
      riderId
      riderName
      phoneNumber
      passengers
      pickUp
      pickUpLat
      pickUpLng
      dropOff
      dropOffLat
      dropOffLng
      pickUpTime
      date
      bidAmount
      requestedDriverIds
      driverId
      driverName
      isRequested
      isAccepted
      isCanceled
      isCompleted
      isExpired
      completedAt
      expiredAt
    }
  }
`;

// Update ride status (ride flow state).
const UPDATE_RIDE_STATUS = gql`
  mutation UpdateRideStatus(
    $id: ID!
    $driverId: ID
    $driverName: String
    $isRequested: Boolean!
    $isAccepted: Boolean!
    $isCanceled: Boolean!
    $isCompleted: Boolean!
    $isExpired: Boolean!
    $canceledBy: CanceledBy
  ) {
    updateRideStatus(
      id: $id
      driverId: $driverId
      driverName: $driverName
      isRequested: $isRequested
      isAccepted: $isAccepted
      isCanceled: $isCanceled
      isCompleted: $isCompleted
      isExpired: $isExpired
      canceledBy: $canceledBy
    ) {
      id
      driverId
      driverName
      isRequested
      isAccepted
      isCanceled
      isCompleted
      isExpired
      canceledBy
    }
  }
`;

// Delete ride.
const DELETE_RIDE = gql`
  mutation DeleteRide($id: ID!) {
    deleteRide(id: $id) {
      message
    }
  }
`;

/* ============================================
   MUTATION HOOKS
   ============================================ */

// Create a new ride.
export const useCreateRide = () => {
  const [
    createRide,
    {
      data: createRideData,
      loading: loadingCreateRide,
      error: errorCreateRide,
    },
  ] = useMutation(CREATE_RIDE, {
    onError: () => {
      // TODO: Remove in production.
      // console.log('Create Ride Error.');
    },
    onCompleted: (data) => {
      // TODO: Remove in production.
      // console.log('Ride Created Successfully.');
      // console.log(`Return data: `, data.createRide);
    },
  });

  return { createRide, loadingCreateRide, errorCreateRide };
};

// Delete an existing ride.
export const useDeleteRide = () => {
  const [
    deleteRide,
    {
      data: deleteRideData,
      loading: loadingDeleteRide,
      error: errorDeleteRide,
    },
  ] = useMutation(DELETE_RIDE, {
    onError: () => {
      // TODO: Delete console logs.
      // console.log('Delete Ride Error.');
    },
    onCompleted: (data) => {
      // TODO: Delete console logs.
      // console.log('Ride Deleted Successfully.');
      // console.log(`Return data: `, data.deleteRide);
    },
  });

  return { deleteRide, loadingDeleteRide, errorDeleteRide };
};

// Update ride status.
export const useUpdateRideStatus = () => {
  const [
    updateRideStatus,
    {
      data: updateRideStatusData,
      loading: loadingUpdateRideStatus,
      error: errorUpdateRideStatus,
    },
  ] = useMutation(UPDATE_RIDE_STATUS, {
    onError: (error) => {
      // TODO: Delete console logs.
      // console.error('Update Ride Status Error:', error);
    },
    onCompleted: (data) => {
      // TODO: Delete console logs.
      // console.log('Ride Status Updated Successfully.');
      // console.log(`Return data: `, data.updateRideStatus);
    },
  });

  return { updateRideStatus, loadingUpdateRideStatus, errorUpdateRideStatus };
};
